import { render, staticRenderFns } from "./AssignSpecialist.vue?vue&type=template&id=ae784492"
import script from "./AssignSpecialist.vue?vue&type=script&lang=js"
export * from "./AssignSpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports